<template>
	<section>
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('ID')"        >ID     <font-awesome-icon v-if="direction.by == 'ID'"        :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('NAME')"      >NOME   <font-awesome-icon v-if="direction.by == 'NAME'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('EXTENSION')" >RAMAL  <font-awesome-icon v-if="direction.by == 'EXTENSION'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('PARENT_ID')" >{{view_nome.setor_nome}}  <font-awesome-icon v-if="direction.by == 'PARENT_ID'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('STATUS')"    >STATUS <font-awesome-icon v-if="direction.by == 'STATUS'"    :icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>

			<transition mode="out-in" name="leftIn">
	    		<tbody v-if="ramais" align="center">
	    			<tr v-for="(ramal, index) in ramais.result.data" :key="index">
						<td>{{ ramal.ID }}</td>
						<td>{{ ramal.NAME }}</td>
						<td>{{ ramal.EXTENSION }}</td>
						<td>{{ get_setor_name(ramal.PARENT_ID) }}</td>
						<td><font-awesome-icon icon="phone" :class="( ramal.STATUS == 1 ) ? 'vermelho' : 'verde' " /></td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(ramal)" /></td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
	    	</transition>
    	</table>

    	<controls  :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
    	<viewRamal :ramal="modal_data"  :action="action"     @alert="show_alert" />
	</section>
</template>

<script>
	import api       from "@/mixins/api.js"
	import replace   from "@/mixins/replace.js"
	import filtros   from "@/components/Tools/Filtro.vue"
	import controls  from "@/components/Tools/Table_Control.vue"
	import viewRamal from "@/components/Modal/Cadastro/Ramal.vue"

	export default {
		name: "Ramais",
		props: ["table", "method"],
		mixins: [api],
		components: { controls, filtros, viewRamal },

		data() { return {
			ramais: null,
			constrol_data: {},
			modal_data: {},
			action: "",
			setores: { status:null, result:null },

			direction: { order: "asc", by: "ID" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "ID",        label: "ID",       type: "text",   data_get: ""},
				{ name: "NAME",      label: "Oparador", type: "text",   data_get: ""},
				{ name: "EXTENSION", label: "Ramal",    type: "text",   data_get: ""},
				{ name: "PARENT_ID", label: "Setor",    type: "select", data_get: "Setor"},
			]
		}},

		created() {
			this.$emit('update:pdf', true)
			this.$emit('update:pdf_title', 'ramais')
			this.$emit('update:pdf_external', true)
			this.$emit('update:pdf_datatable', 'Ramal')
			this.$emit('update:pdf_header', ["ID", "RAMAL", "NOME", "SETOR"] )
			this.$emit('update:pdf_body', ["ID", "EXTENSION", "NAME", "setor"] )
			this.get_setores()
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			},

			view_nome(){ return this.$store.state.config_view_menu },
		},

		methods: {
			async get_setores() {
				this.setores = await this.GET("Setor")
			},

			get_setor_name(payload) {
				if(this.setores){
					for (var i = 0; i <= this.setores.result.length -1; i++) {
						if ( this.setores.result[i].ID == payload){
							return this.setores.result[i].NAME
						}
					}
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.$emit('update:pdf_string_filter', payload)
				this.get_data()
			},

			async get_data() {
				this.ramais = null
				this.ramais = await this.GET("Ramal", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`)

				this.constrol_data = {
					current_page: this.ramais.result.current_page,
					last_page:    this.ramais.result.last_page,
					per_page:     this.ramais.result.per_page,
					total:        this.ramais.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			view(payload) { 
				this.modal_data = payload
				this.action = "view"
				$("#modal-cadastro-ramal").modal()
			},

			add() { 
				this.modal_data = {}
				this.action = "add"
				$("#modal-cadastro-ramal").modal()
			},

			show_alert(payload) {
				$("#modal-cadastro-ramal").modal('hide')
				this.get_data()

				this.$emit('alert', payload)
			},

			pdf_data() {
				const header = ["ID", "RAMAL", "SETOR"]
				const body   = []
				const data   = this.ramais.result.data

				data.forEach( index => {
					const row = [
						index.ID,
						index.EXTENSION,
						this. get_setor_name(index.PARENT_ID)
					]

					body.push(row)
				})
				
				return {type: "ramais", user: this.$store.state.user.name, header, body}
			},
		}
	};
</script>

<style>
	
</style>